<template>
    <div class="">
        <a-space>
            <a-date-picker v-model:value="requestPayload.localDate" placeholder="日期" @change="handleSelectTime"
                allowClear></a-date-picker>

            <a-range-picker v-model:value="rangeTime" @change="handleSelectRangeTime" allowClear></a-range-picker>

            <a-select v-model:value="requestPayload.type" style="width: 180px;" :options="processOption"
                placeholder="工序" @change="handleSearch" allowClear></a-select>

        </a-space>

        <a-table :data-source="table.data" :columns="columns" rowKey="id" class="table-space"
            :scroll="{ x: 'calc(100vw - 300px)', y: 'calc( 100vh - 300px )' }" :pagination="false">
            <template #picture="{ record }">
                <a-image v-for="img in JSON.parse(record.picture)" :key="img" :width="50" :src="img" />
            </template>

            <template #video="{ record }">
                <video v-for="video in JSON.parse(record.video)" :src="video" controls width="120" :key="video"></video>
            </template>

            <template #notes="{ record }">
                <div v-if="record.notes">
                    <template v-for="(item, index) in JSON.parse(record.notes)" :key="index">
                        <a-image v-for="img in JSON.parse(item.picture)" :key="img" :width="50" :src="img" />

                        <video v-for="video in JSON.parse(item.video)" :src="video" controls width="120"
                            :key="video"></video>

                        <div>
                            {{ item.desc }}
                        </div>
                    </template>
                </div>
            </template>

            <template #type="{ record }">
                {{ getProcessName(record.type) }}
            </template>

            <template #action="{ record }">
                <a-button @click="handleReply(record)" size="small" type="primary">工程回复</a-button>
            </template>
        </a-table>

        <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @cancel="handleCancel"
            @ok="handleUpdateReply">
            <a-textarea v-model:value="modalConfig.reply" allowClear placeholder="请输入工程回复内容" auto-size>

            </a-textarea>
        </a-modal>
    </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue';
import {
    getAbnormalProblemHandleList,
    getWIRecordList,
    saveOrUpdateWIRecord,
} from "@/request/view/product";
import {
    defaultModel,
} from "@/views/productDaily/components/instruction/option";
import { useTable } from "@/views/notice/serve/table";
import modelCascader from '@/components/cascader/index.vue'
import { getPQCProductOption, getProcessName } from "@/views/productDaily/serve/option";
import { Toast } from '@/utils';
import { useRoute } from 'vue-router';

export default defineComponent({
    props: {
        type: String,
    },
    components: {
        modelCascader
    },
    setup(props) {
        const modalConfig = reactive({
            title: '工程回复',
            visible: null,
            id: null,
            reply: null,
        });

        const route = useRoute();

        const abnormalColumns = [
            {
                title: "序号",
                dataIndex: "id",
                width: 80,
                align: "center",
                fixed: "left"
            },
            {
                title: "时间",
                dataIndex: "localDate",
                width: 120,
                align: "center",
                fixed: "left"
            },
            {
                title: "工序",
                slots: {
                    customRender: "type"
                },
                width: 120,
                align: "center",
                fixed: "left"
            },
            {
                title: "问题",
                dataIndex: "problem",
                width: 165,
                align: "center",
            },
            {
                title: "图片",
                dataIndex: "picture",
                width: 165,
                align: "center",
                slots: { customRender: "picture" },
            },
            {
                title: "视频",
                dataIndex: "video",
                width: 165,
                align: "center",
                slots: { customRender: "video" },
            },
            {
                title: "部件名称",
                dataIndex: "componentName",
                width: 165,
                align: "center",
            },
            {
                title: "部件编码",
                dataIndex: "componentCode",
                width: 165,
                align: "center",
            },
            {
                title: "原因",
                dataIndex: "reason",
                width: 165,
                align: "center",
            },
            {
                title: "处理措施",
                dataIndex: "handlingMeasures",
                width: 165,
                align: "center",
            },
            {
                title: "处理类型",
                dataIndex: "processType",
                width: 100,
                align: "center",
            },
            {
                title: "状态",
                dataIndex: "status",
                width: 100,
                align: "center",
            },
            {
                title: "备注",
                dataIndex: "notes",
                width: 165,
                align: "center",
                slots: {
                    customRender: "notes",
                },
            },
        ];

        const wiRecordColumns = [
            {
                title: "序号",
                dataIndex: "id",
                width: 80,
                align: "center",
                fixed: "left"
            },
            {
                title: "时间",
                dataIndex: "localDate",
                width: 120,
                align: "center",
                fixed: "left"
            },
            {
                title: "工序",
                slots: {
                    customRender: "type"
                },
                width: 120,
                align: "center",
                fixed: "left"
            },
            {
                title: "反馈内容",
                dataIndex: "feedbackContent",
                width: 165,
                align: "center",
            },
            {
                title: "工程回复",
                dataIndex: "reply",
                width: 165,
                align: "center",
            },
            {
                title: "图片",
                dataIndex: "picture",
                width: 165,
                align: "center",
                slots: {
                    customRender: "picture",
                },
            },
            {
                title: "视频",
                dataIndex: "video",
                width: 165,
                align: "center",
                slots: {
                    customRender: "video",
                },
            },
            {
                title: "应对措施",
                dataIndex: "countermeasures",
                width: 165,
                align: "center",
            },
            {
                title: "工程对接人",
                dataIndex: "contactPerson",
                width: 140,
                align: "center",
            },
            {
                title: "操作",
                dataIndex: "action",
                width: 100,
                align: "center",
                slots: {
                    customRender: "action"
                }
            }
        ];

        const processOption = getPQCProductOption();

        const columns = ref([]);

        const rangeTime = ref([]);

        const {
            requestConfig,
            table,
            requestPayload,
            initPayload,
            getListData,
            searchData,
            deleteRecords,
            hanldeUpdatePageNum,
        } = useTable();

        initPayload({
            endDate: null,
            localDate: null,
            produceOrTpc: route.meta.produceOrTpc,
            project: 'swan',
            startDate: null,
            type: null
        })

        const init = () => {
            columns.value.length = 0;
            requestPayload.startDate = null;
            requestPayload.endDate = null;
            requestPayload.localDate = null;
            requestPayload.type = null;
            switch (props.type) {
                case 'abnormalIssues':
                    requestConfig.pull_fn = getAbnormalProblemHandleList;
                    columns.value.push(...abnormalColumns);
                    break;
                case 'workingInstruction':
                    requestConfig.pull_fn = getWIRecordList;
                    columns.value.push(...wiRecordColumns);
                    break;
                default:
                    break;
            }

            getListData({ unPagingRequest: true });
        };

        const handleReply = (record) => {
            modalConfig.visible = true;
            modalConfig.id = record.id;
            modalConfig.reply = record.reply;
        };

        const handleCancel = () => {
            modalConfig.id = null;
            modalConfig.visible = false;
            modalConfig.reply = null;
        };

        const handleSearch = () => {
            getListData({ unPagingRequest: true });
        };

        const handleUpdateReply = () => {
            saveOrUpdateWIRecord({
                id: modalConfig.id,
                reply: modalConfig.reply
            }).then((res) => {
                const type = res.code === 200 ? 'success' : 'warning';
                Toast(type, res.message, 3);
                handleCancel();
                handleSearch();
            }).catch((err) => {
                handleCancel();
            });
        };

        const handleSelectRangeTime = (e, stringTime) => {
            const [startDate, endDate] = stringTime;
            requestPayload.localDate = null;
            if (startDate && endDate) {
                requestPayload.startDate = startDate;
                requestPayload.endDate = endDate;
            } else {
                requestPayload.startDate = null;
                requestPayload.endDate = null;
            }
            handleSearch();
        };

        const handleSelectTime = (e, stringTime) => {
            requestPayload.startDate = null;
            requestPayload.endDate = null;
            requestPayload.localDate = stringTime;
            rangeTime.value.length = 0;
            handleSearch();
        };

        return {
            init,
            handleSearch,
            getProcessName,
            handleSelectRangeTime,
            handleSelectTime,
            handleReply,
            handleUpdateReply,
            handleCancel,
            modalConfig,
            processOption,
            requestPayload,
            rangeTime,
            table,
            columns,
        };
    }
});
</script>

<style lang="less" scoped>
.table-space {
    margin-top: 10px;
}
</style>
